import { ZoneType } from '../../api/static/zones';
import ConfiguratorTextureCanvasLayerText from './ConfiguratorTextureCanvasLayerText';
import ConfiguratorTextureCanvasLayerImage from './ConfiguratorTextureCanvasLayerImage';
import { filterProps } from '../../utils/ObjectUtils';

const ComponentMap = Object.freeze({
  [ZoneType.TEXT]: ConfiguratorTextureCanvasLayerText,
  [ZoneType.IMAGE]: ConfiguratorTextureCanvasLayerImage,
});

export default {
  name: 'ConfiguratorTextureCanvasLayerFactory',
  functional: true,
  props: {
    layer: {
      type: Object,
      required: true,
      validator(v) {
        return 'type' in v && Object.values(ZoneType).includes(v.type);
      },
    },
    debug: Boolean,
    color: { type: String, default: undefined },
  },
  /**
   *
   * @param h
   * @param context
   * @return {VNode}
   */
  render(h, context) {
    const {
      props: { layer, debug, color },
    } = context;

    const props = Object.assign(
      { debug, color },
      filterProps(layer, ['x', 'y', 'width', 'height', 'rotation'])
    );

    const { _customization, defaultValue } = layer;

    switch (layer.type) {
      case ZoneType.TEXT: {
        Object.assign(props, {
          text:
            _customization?.text !== undefined
              ? _customization.text
              : defaultValue,
          align: layer.align,
          fontSize: _customization?.fontSize || layer.fontSize,
          italic: _customization?.italic || layer.italic,
          underlined: _customization?.underlined || layer.underlined,
          typoId: _customization?.typoId || layer.typoId,
        });

        if (!props.color) {
          if (_customization?.color) {
            props.color = _customization.color;
          } else if (layer.color) {
            props.color = layer.color;
          }
        }

        break;
      }

      case ZoneType.IMAGE: {
        Object.assign(props, {
          url:
            _customization?.url !== undefined
              ? _customization.url
              : defaultValue,
          innerWidth: _customization?.width,
          innerHeight: _customization?.height,
        });

        break;
      }

      default: {
        throw new Error('Zone type not implemented.');
      }
    }

    if (_customization) {
      Object.assign(props, {
        innerX: _customization.x,
        innerY: _customization.y,
        innerScaleX: _customization.scaleX,
        innerScaleY: _customization.scaleY,
        innerRotation: _customization.rotation,
      });
    }

    return h(
      ComponentMap[layer.type],
      { ...context.data, props },
      context.children
    );
  },
};
